/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */

import { Features, core } from '@tock/coretypes';
import { SharedAppConstants } from '@tock/shared-app-constants';
import { forEach } from 'es-toolkit/compat';

type ReleaseBundles = { [P in core.Feature.FeatureName]?: core.Feature.FeatureName[] };
interface FeaturesState {
  features: Features;
  globalFeatures: Features;
  isInitialized: boolean;
}

export const initialState: FeaturesState = {
  features: {},
  globalFeatures: {},
  isInitialized: false,
};

/**
 * How to use release bundles:
 * Release bundles allow you to group multiple feature flags into a single flag,
 * such that enabling that single flag will implicitly enable all its associated flags.
 *
 * In the following example, enabling BUNDLE_NAME_1 will cause
 * FEATURE_FLAG_1 and FEATURE_FLAG_2 to be enabled.
 *
 * const releaseBundles: ReleaseBundles = {
 *   BUNDLE_NAME_1: [
 *     'FEATURE_FLAG_1',
 *     'FEATURE_FLAG_2'
 *   ],
 *   BUNDLE_NAME_2: [
 *     'FEATURE_FLAG_3',
 *     'FEATURE_FLAG_4'
 *   ]
 * }
 */
const releaseBundles: ReleaseBundles = {};
export default function reducer(state = initialState, action: BaseTockAction): FeaturesState {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.FEATURES_FETCH_ALL_DONE: {
      const features: Features = {};
      forEach(payload, (feature: core.Feature.FeatureName) => {
        features[feature] = true;
      });

      forEach(releaseBundles, (bundle, masterFeature) => {
        if (features[masterFeature as core.Feature.FeatureName]) {
          forEach(bundle, (feature) => (features[feature] = true));
        }
      });

      return {
        ...state,
        features,
        isInitialized: true,
      };
    }
    case SharedAppConstants.FEATURES_FETCH_GLOBAL_DONE: {
      const globalFeatures: Features = {};
      forEach(payload, (feature: core.Feature.FeatureName) => {
        globalFeatures[feature] = true;
      });
      return {
        ...state,
        globalFeatures,
        isInitialized: true,
      };
    }
    default:
      return state;
  }
}
